import { render, staticRenderFns } from "./MRStatusCallout.vue?vue&type=template&id=1f1966fe"
import script from "./MRStatusCallout.vue?vue&type=script&lang=ts"
export * from "./MRStatusCallout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports